import React from 'react';
import { Button, Card, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaHourglassHalf } from 'react-icons/fa';

export default function Pending() {
    return (
        <div style={{ minHeight: 'calc(100vh - 281px)', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Container className="d-flex flex-column align-items-center">
                <Card style={{ width: '22rem', textAlign: 'center', padding: '20px', borderRadius: '10px', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)' }}>
                    <FaHourglassHalf size={60} color="orange" />
                    <Card.Body>
                        <Card.Title style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>Pago en proceso</Card.Title>
                        <Card.Text style={{ color: '#555' }}>
                            Estamos procesando tu pago.  
                            En unos minutos recibirás la confirmación en tu correo.
                        </Card.Text>
                        <Button variant="warning" as={Link} to="/">Volver al inicio</Button>
                    </Card.Body>
                </Card>
            </Container>
        </div>
    );
}
